import { useEffect, useRef } from 'react';

import noop from 'lodash/noop';


function useUpdateEffect(callback, deps = [], clear = noop) {
  const counterRef = useRef(0);
  useEffect(() => {
    counterRef.current += 1;
    if (counterRef.current <= 1) {
      return;
    }
    callback();
    return () => {
      clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useUpdateEffect;
